/**
 * SearchBar.tsx
 */

// imports
import { useRef } from "react";
import { useSearchOptions } from "../../providers/SearchOptions";
import AppSelect from "../AppSelect/AppSelect";
import { Button } from '@mui/material';
import { useTranslation } from "react-i18next";


// import styling
import './SearchBar.scss';

/**
 * This displays the list of search filters that can be used to search the backend
 * @param props 
 * @returns The Searchbar Component
 */
export const SearchBar = ({
                              includeDateField,
                              showAll = true,
                              setSearchState,
                              setSearchVisibility,
                              defaultSearchState,
                              searchState,
                              dateOptions = [] as string[],
                              showCancel = true,
                              setSearchName='',
                              selectDateLabel='Block Month'
    }) => {

    const {equipmentOptions, positionOptions, baseOptions} = useSearchOptions();
    let equipment = showAll ? equipmentOptions : equipmentOptions.filter(f => f.toLowerCase() !== 'all');

    const { t } = useTranslation();
    const selects = useRef([]);

    const restorePosition = () => {
        setSearchState(defaultSearchState);
        setSearchVisibility(false);
      }
    
    /** handleChange
     * This handles any change in the filter selection - triggers on selected item change
     * @param event This is the event object passed into the function by the event source
     */
    
    const callSearch = () => {
      setSearchState({
        selectedDate: dateOptions.length ? selects.current[selectDateLabel].querySelector('input').value : searchState.selectedDate,
        selectedBase: selects.current['Base'].querySelector('input').value,
        selectedEquipment: selects.current['Equipment'].querySelector('input').value,
        selectedPosition: selects.current['Rank'].querySelector('input').value
      });
    };

    // this will be called when search is changed.
    // important ONLY update dbm searchstate on clicking the search button callSearch
    // removing this because we want this handled in the dbm report
    // useEffect(() => {
    //   if(!searchState) return;
    //   searchFunction(searchState);
    // },[searchState]);

    return(
        // wrap everything in the FilterOptionsProvider
        <div className="search-bar">
            {/* if includeDateField is true - show a date field */}
            { includeDateField ? 
                <div className="search-filter month-filter">
                    <AppSelect multiSelect={false} selectRef={selects} selectLabel={selectDateLabel} selectedItem={searchState.selectedDate || ''} fillElements={dateOptions || []} />
                </div>  
                :
                null
            }

            {/* Filters to search */}
            <div className="search-filter">
                <AppSelect multiSelect={false} selectRef={selects} selectLabel="Base" selectedItem={searchState.selectedBase || ''} fillElements={baseOptions || []} />
            </div>

            <div className="search-filter">
                <AppSelect multiSelect={false} selectRef={selects}  selectLabel="Equipment" selectedItem={searchState.selectedEquipment || ''} fillElements={equipment || []} />
            </div>

            <div className="search-filter">
                <AppSelect multiSelect={false} selectRef={selects} selectLabel="Rank" selectedItem={searchState.selectedPosition || ''} fillElements={positionOptions || []} />
            </div>            

            {/* Search button and cancel button */}
            <div className="search-buttons">
            <Button variant="outlined" className="search-btn" onClick={callSearch}>{setSearchName === '' ? t('SearchBar.searchButton') : setSearchName}</Button>
                {showCancel && <Button variant="outlined" className="cancel-btn" onClick={restorePosition}>{t('SearchBar.cancelButton')}</Button>}
            </div>
        </div>
    )
}
